import React from 'react'
import { useTranslation } from 'react-i18next'
import "./Copyrights.css"

const Copyrights = () => {
    const { t } = useTranslation()
    return (
        <div className="footer">
            <p>{t('footer_copyrights')}</p>
            <p>22.281716506364702, 73.20625609810773</p>
        </div>
    )
}

export default Copyrights
